import React, { useEffect } from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

import { reverseFormatDate } from '../../../utils/dateFunctions';
import { downloadCsv } from '../../../utils/downloadCSV';
import DataSetsResultsModal from '../DataSetsResultsModal';

const fileName = 'Referral Created';
const fields =
    'PT_ID,Current_Status,Current_Reason,Eligibility_Group,Referral_Date,Participant_Created_Date,Days_Between_Referral_Date_and_Created_Date,PO_Number';
const WAIT = 5000;

const CreateReferralCsv = ({ isOpen, onClose, rows, contractName }) => {
    // USE EFFECTS
    useEffect(() => {
        const values = Object.values(
            rows.map((el) => {
                // eslint-disable-next-line
                const { createdBy, initialAppointmentDate, ...rest } = el;
                const formattedRow = {
                    ...rest,
                    referralDate: reverseFormatDate(el.referralDate),
                    dateCreated: reverseFormatDate(el.dateCreated)
                };
                return Object.values(formattedRow);
            })
        );

        const name = `${fileName}_${contractName}_${format(new Date(), `dd_MMM_yyyy_HH_mm`)}`;
        downloadCsv(fields, values, name);
        const timerId = setTimeout(() => onClose(), WAIT);
        return () => clearTimeout(timerId);
    }, [rows]);

    // RENDER
    return (
        <DataSetsResultsModal
            isOpen={isOpen}
            onCancel={onClose}
            resultRowsLength={rows.length || 0}
            dataSetName="Referrals Created"
        />
    );
};

CreateReferralCsv.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    rows: PropTypes.arrayOf(PropTypes.object),
    contractName: PropTypes.string
};

export default CreateReferralCsv;
